export function renderOptions(params) {
  let option = {
    color: ['#3398DB'],
    tooltip: {
      trigger: 'axis',
      formatter: params.tipsformatter, // '{b}<br/>{a}:{c}' + '台',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '0%',
      top: '8%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      axisTick: {
        show: false
      },
      data: params.xAxis,
      axisTick: {
        alignWithLabel: true
      },
      axisLabel: {
        color: '#fff'
      }
    }, ],
    yAxis: [{
      type: 'value',
      interval: 1,
      axisLabel: {
        color: '#fff'
      },
      splitLine: {
        show: false
      },
    }],
    series: params.series
  };

  return option
}